import React from "react";
import * as SC from "./DataGrid.style";

export const DataGridRecords = ({
  columns,
  rows,
  handleRowClick = (row) => null,
  visibility = [],
  disablePointerCursor = false,
  isMobileWidth = false,
  isFirstLoad,
  highlightRowName = undefined,
  highlightRowValue = undefined,
}) => {
  const visibleSize = {
    xs: 12,
    sm: 12,
    md: 12,
  };

  const getMdByField = (field) =>
    columns.find((item) => item.field === field)?.md ?? 0;

  if (!isMobileWidth && visibility?.length > 0) {
    visibleSize.md = visibility.reduce(
      (acc, next) => acc + getMdByField(next),
      0
    );
    visibleSize.sm = visibleSize.md;
    visibleSize.xs = visibleSize.md;
  }

  return (
    <SC.RecordsHolder>
      {
        // @ts-ignore
        rows?.map((row, index) => (
          <SC.Record
            key={`${row?.id}-${index}`}
            container
            wrap={"wrap"}
            columns={visibleSize}
            onClick={() => handleRowClick(row)}
            sx={{
              "&:hover": {
                cursor: disablePointerCursor ? "default" : "pointer",
              },
            }}
            className={
              highlightRowName && row[highlightRowName] === highlightRowValue
                ? "highlighted-row"
                : ""
            }
          >
            {columns.map(
              ({ label, field, renderer, xs, sm, md, align = "left" }) =>
                (isMobileWidth ||
                  visibility.length === 0 ||
                  visibility.includes(field)) && (
                  <SC.RecordItem
                    key={`${row.id}-${label}-${field}`}
                    item
                    xs={xs}
                    sm={sm}
                    md={md}
                    sx={{ textAlign: align }}
                  >
                    {renderer ? renderer(row) : row[field]}
                  </SC.RecordItem>
                )
            )}
          </SC.Record>
        ))
      }
      {isFirstLoad && <SC.NoDataHolder>Loading...</SC.NoDataHolder>}
      {!isFirstLoad && rows?.length === 0 && (
        <SC.NoDataHolder>No data</SC.NoDataHolder>
      )}
    </SC.RecordsHolder>
  );
};
